<template>
    <div class="DataCompare bg_fff">
        <!--   头部 title   -->
        <div ref="compareBox">
            <section class="compareTop">
                <!--            <img @click="popupVisible = true" class="viewImg" src="../assets/img/compare/list.svg" alt="打开选择弹窗">-->
                <div class="titleBox fs24 flex_box co_fff text_c font_b">
                    <p v-if="target1">{{ labelData[0] }}</p>
                    <p v-if="target1">{{ labelData[1] }}</p>
                </div>
                <p class="co_fff8 text_c fs12">{{ dateRange }}</p>
            </section>
            <!-- 显示替换内容 -->
            <div class="bg_fff" v-if="target1">
                <ExportReportTitle title="舆情总览" index="0"></ExportReportTitle>
                <LineChart
                    ref="healthLineRef"
                    v-if="LineChartData"
                    :renderData="LineChartData"
                    :isCompare="true"
                    :labelData="labelData"
                    :periodStr="paramsData.dateStr"
                    :formatxAxisDate="formatLineChartxAxisDate"
                />
                <p class="cuttingLine"></p>
                <div v-if="target1.spreadStats.fameHealthyMap">
                    <TableBar
                        ref="areaHealthRef"
                        key="healthData"
                        title="地域健康指数"
                        :isMapContent="true"
                        :labelData="labelData"
                        :timeData="paramsData.dateStr"
                        :renderData="{ target1: target1.spreadStats.fameHealthyMap, target2: target2.spreadStats.fameHealthyMap, }"
                        :showDataArr="['health', 'province']"
                    ></TableBar>
                    <p class="cuttingLine"></p>
                </div>

                <BarChartVertical
                    ref="barChartAffectRef"
                    v-if="target1"
                    key="barChartAffect"
                    chartId="barChartAffect"
                    :hasContent="true"
                    :hasTitle="true"
                    :keyData="[ 'name', 'total' ]"
                    :labelData="labelData"
                    chartTitle="事件数(件)"
                    :timeData="paramsData.dateStr"
                    :entityType="paramsData.type"
                    :renderData="{ target1: target1.spreadStats.broadcastEffect, target2: target2.spreadStats.broadcastEffect, }"
                />
            </div>
            <div class="bg_fff" v-if="target1">
                <ExportReportTitle title="风险分析" index="1"></ExportReportTitle>
                <TableBar  v-if="target1"
                           ref="riskLevelRef"
                           title="风险类型及等级分布"
                           :renderData="{ target1: target1.general.yinbaoRiskCounts, target2: target2.general.yinbaoRiskCounts, }"
                           :labelData="labelData"
                           key="contentRisks"
                           chartId="contentRisksChart"
                           :setDefaultContent="setRiskContent"
                           chartTitle="监管关注的十类风险"
                           :showDataArr="['count', 'category']"
                ></TableBar>
                <BarChartVertical
                    v-if="target1"
                    :labelData="labelData"
                    :entityType="paramsData.type"
                    :chartTitle="paramsData.type =='industry' ? '事件数(件)' : '敏感报道量(篇)'"
                    :renderData="{ target1: target1.general.riskLevelCounts, target2: target2.general.riskLevelCounts, }"
                    key="barChartRisk"
                />
                <p class="cuttingLine"></p>
                <PieCircleChart
                    ref="riskCompanyRef"
                    v-if="target1.general.subCompanyHealth"
                    :isDouble="true"
                    :entityType="paramsData.type"
                    :labelData="labelData"
                    :timeData="paramsData.dateStr"
                    :renderData="{ target1: target1.general.subCompanyHealth, target2: target2.general.subCompanyHealth, }"/>

            </div>
            <div class="bg_fff" v-if="target1">
                <ExportReportTitle title="媒体传播" index="2"></ExportReportTitle>
                <BarChartVertical
                    ref="barChartChannelRef"
                    key="barChartChannel"
                   title="渠道报道倾向"
                   chartId="barChartChannel"
                   chartTitle="报道量(篇)"
                   :hasContent="true"
                   :isChannel="true"
                   :hasTitle="true"
                   :keyData="[ 'name', 'total' ]"
                   :labelData="labelData"
                   :timeData="paramsData.dateStr"
                   :entityType="paramsData.type"
                   :renderData="{ target1: target1.spreadStats.channelTendency, target2: target2.spreadStats.channelTendency, }"/>
                <CommonTable  :onlyTable="true" :tableData="tableData" tableName="hasPercent table2" :hasPercentBar="true"></CommonTable>
                <p v-if="false" class="cuttingLine"></p>
                <div class="articleBox ">
                    <p class="homeComTitle hasLine mt16">
                        <span class="titleLine"></span>
                        <span class="flex_1">重点事件</span>
                    </p>

                    <section>
                        <div class="fs14 co_333 text_l event_desc">
                            <p v-if="target1.mainEvent"  v-html="tagrget1MainEventStr"></p>
                        </div>

                        <div ref="target1NegImage">
                            <img class="titleImg mt20 ml20" src="../assets/img/icon/negativeTop5.png" alt="敏感标题">
                            <ArticleList
                                :assignData="target1Negative"
                                :onlyList="true"
                                :noIndex="false"
                                :timeKey="paramsData.type == 'industry' ? 'latestDateStr' : 'createdStr'">
                            </ArticleList>
                        </div>
                        <div  ref="target1PosImage">
                            <img class="titleImg mt20 ml20" src="../assets/img/icon/positiveTop5.png" alt="正面标题">
                            <ArticleList
                                addClass="hideLastBorder"
                                :assignData="target1Positive"
                                :assignPositive="true"
                                :onlyList="true"
                                :noIndex="false"
                                :timeKey="paramsData.type == 'industry' ? 'latestDateStr' : 'createdStr'">
                            </ArticleList>
                        </div>

                    </section>

                    <section>
                        <div class="fs14 co_333 text_l event_desc">
                            <p v-if="target2.mainEvent" v-html="tagrget2MainEventStr"></p>
                        </div>

                        <section ref="target2NegImage">
                            <img class="titleImg mt20 ml20" src="../assets/img/icon/negativeTop5.png" alt="敏感标题">
                            <ArticleList
                                :assignData="target2Negative"
                                :onlyList="true"
                                :noIndex="false"
                                :timeKey="paramsData.type == 'industry' ? 'latestDateStr' : 'createdStr'">
                            </ArticleList>
                        </section>
                        <div  ref="target2PosImage">
                            <img class="titleImg mt20 ml20" src="../assets/img/icon/positiveTop5.png" alt="正面标题">
                            <ArticleList
                                addClass="hideLastBorder"
                                :assignData="target2Positive"
                                :assignPositive="true"
                                :onlyList="true"
                                :noIndex="false"
                                :timeKey="paramsData.type == 'industry' ? 'latestDateStr' : 'createdStr'">
                            </ArticleList>
                        </div>

                    </section>

                </div>
            </div>
        </div>
        <LoadingPage :loading="loading"/>

        <!-- 底部 操作按钮 -->
        <ExportButton
            page="compare"
            class="exportBtn"
            :subject="subject"
            :startTime="startTime"
            :endTime="endTime"
            @handelPptAndImageData="handelPptAndImageData"/>
    </div>
</template>

<script>
import moment from 'moment'
import _ from 'lodash'
import utils from "@/util/common";
import covertData from "@/util/covertData";
import common from "@/util/common";


export default {
    name: "ExportDataCompare",
    components: {
        LineChart(render){ require(["@/components/chart/LineChart"], render) },
        TableBar(render){ require(["@/components/entity/TableBar"], render) },
        BarChartVertical(render){ require(["@/components/chart/BarChartVertical"], render) },
        PieCircleChart(render){ require(["@/components/chart/PieCircleChart"], render) },
        CommonTable(render){ require(["@/components/entity/CommonTable"], render) },
        ArticleList(render){ require(["@/components/entity/ArticleList"], render) },
        // ChoosePopup(render){ require(["@/components/common/ChoosePopup"], render) },
        ExportReportTitle(render){ require(["@/components/common/ExportReportTitle"], render) },
        ExportButton(render){ require(["@/components/common/ExportButton"], render) },
        LoadingPage(render){ require(["@/components/common/LoadingPage"], render) },

    },
    data() {
        return {
            formatLineChartxAxisDate: true,
            loading: false,
            mainNav: [ '舆情总览', '风险分析', '媒体传播', ],
            activeNav: '舆情总览',
            paramsData: {
                startDate: moment().subtract(3, 'day').startOf('day').valueOf(),
                endDate: moment().endOf('day').valueOf(),
                targetId1: '银行',
                targetId2: '证券',
                type: 'industry',
                dateStr: '今日',
            },
            LineChartData: null, // 舆情健康指数 趋势 渲染数据
            labelData: null, // 舆情健康指数 title
            target1: null, // 对比数据
            target2: null, // 对比数据
            startTime: null, // 对比开始时间
            endTime: null, // 对比结束时间
            tableData: null, // 媒体传播 对比 table
            target1Negative: null,
            target1Positive: null,
            target2Negative: null,
            target2Positive: null,
            activeIndex: 0, // 当前选中
            popupVisible: false, // 是否显示选择弹窗

            token: utils.getCookie("xinhuaToken") || this.$route.query.xinhuaToken,
            imageUrl: null,
            setRiskContent: null, // 设置 风险等级对比 文案
            entityLabel: "企业",
            unitKey: "篇",
            unitLabel: "敏感事件报道",
            subject: "",//邮件标题
            dateRange: "",
            tagrget1MainEventStr:"",
            tagrget2MainEventStr:""
        }
    },
    mounted() {
        this.paramsData = this.$route.query;
        this.getData()
    },
    methods: {
        async getData() {
            this.loading = true;
            this.target1 = null;
            this.target2 = null;
            let res = await this.baseApi.compare(this.paramsData);
            if(res !== 'confirm') {
                let { target1, target2, startDate, endDate } = res;

                this.LineChartData = {
                    each: target1.healths || [],
                    each1: target2.healths || [],
                    mainChief: _.get(target1, "eventTop5.negative[0]", null),
                    mainChief1: _.get(target2, "eventTop5.negative[0]", null),
                }

                if(this.paramsData.type == "industry"){
                    this.entityLabel = "行业"
                    this.unitKey = "件";
                    this.unitLabel=  "敏感事件";
                    target1.name = utils.convertEntityName(target1.name);
                    target2.name = utils.convertEntityName(target2.name)
                }

                target1.spreadStats.channelTendency = _.orderBy(target1.spreadStats.channelTendency, ["level"], ["desc"]);
                target2.spreadStats.channelTendency = _.orderBy(target2.spreadStats.channelTendency, ["level"], ["desc"]);

                this.labelData = [target1.name, target2.name]
                this.target1 = target1;
                this.target2 = target2;
                this.startTime = startDate;
                this.endTime = endDate;
                this.dateRange = common.dateStrRange(startDate, endDate);
                this.subject = `${this.target1.name}-${this.target2.name} ${common.dateStrRange(startDate, endDate, "~", "YYYY-MM-DD")}`;


                let table1 = target1.spreadStats.channelTendency,
                    table2 = target2.spreadStats.channelTendency,
                    total1 = _.sumBy(table1, 'total'),
                    total2 = _.sumBy(table2, 'total'),
                    negative1 = _.sumBy(table1, 'negative'),
                    negative2 = _.sumBy(table2, 'negative');

                this.tableData = {
                    head: [
                        {name: `对比${this.entityLabel}`, key: "item"},
                        {name: '敏感报道占比', key: 'percent'},
                    ],
                    body: [
                        { item: target1.name, percent: utils.formatPercentAndCeil(negative1, total1), },
                        { item: target2.name, percent: utils.formatPercentAndCeil(negative2, total2), className: 'bg_f29e01', },
                    ]
                }
                this.target1Negative = target1.eventTop5.negative;
                this.target1Positive = target1.eventTop5.positive;
                this.target2Negative = target2.eventTop5.negative;
                this.target2Positive = target2.eventTop5.positive;

                this.setContent(target1, target2)
            }

            this.loading = false;
        },
        setContent(target1, target2) {
            let riskTotal1 = _.sumBy(target1.general.riskLevelCounts, 'count'),
                riskTotal2 = _.sumBy(target2.general.riskLevelCounts, 'count');

            let target1ContentRiskMap = _.get(target1, "general.yinbaoRiskCounts[0]", null);
            let target2ContentRiskMap = _.get(target2, "general.yinbaoRiskCounts[0]", null);
            let cat1 = "", cat2="", count1= 0 ,count2 = 0;
            if(target1ContentRiskMap){
                cat1 = target1ContentRiskMap.category;
                count1 = target1ContentRiskMap.count;
            }
            if(target2ContentRiskMap){
                cat2 = target2ContentRiskMap.category;
                count2 = target2ContentRiskMap.count;
            }

            this.setRiskContent =  `<p>${ target1.name }：${this.paramsData.dateStr}，本${this.entityLabel}${this.unitLabel}${ riskTotal1 }${this.unitKey}，`;

            if(cat1){
                this.setRiskContent += `最多的风险类别是【${ cat1 }】，相关${this.unitLabel}${ count1 }${this.unitKey}，占比${ utils.formatPercentAndCeil(count1, riskTotal1) }%。</p>`
            } else {
                this.setRiskContent += `暂无风险点。</p>`;
            }

            this.setRiskContent += `<p>${ target2.name }：${this.paramsData.dateStr}，本${this.entityLabel}${this.unitLabel}${ riskTotal2 }${this.unitKey}，`;

            if(cat2){
                this.setRiskContent += `最多的风险类别是【${ cat2 }】，相关${this.unitLabel}${ count2 }${this.unitKey}，占比${ utils.formatPercentAndCeil(count2, riskTotal2) }%。</p>`
            } else {
                this.setRiskContent += `暂无风险点。</p>`;
            }


            //重点事件 tagrget1MainEventStr
            if(target1.mainEvent){
                this.tagrget1MainEventStr = `<p>${ target1.name }：${this.paramsData.dateStr }，本${this.entityLabel}发生重点事件如下，其中《<a :href=${target1.mainEvent.uri} class="co_333" target="_blank"><b>${ target1.mainEvent.title }</b></a>》风险等级最高，需重点关注。</p>`
            }
            if(target2.mainEvent){
                this.tagrget2MainEventStr = `<p>${ target2.name }：${this.paramsData.dateStr }，本${this.entityLabel}发生重点事件如下，其中《<a :href=${target2.mainEvent.uri} class="co_333" target="_blank"><b>${ target2.mainEvent.title }</b></a>》风险等级最高，需重点关注。</p>`
            }
        },
        changeData(index) {
            this.activeIndex = index;
            let dataName = 'target' + (index + 1);
            this.assignNegative = this[dataName].eventTop5.negative;
            this.assignPositive = this[dataName].eventTop5.positive;
        },

        async handelPptAndImageData(){
            this.canvasImage();
            this.handelPptData();
        },
        async handelPptData(){

            let {content: healthLineHtml} = this.$refs.healthLineRef;
            let {content: affectHtml} = this.$refs.barChartAffectRef;
            let {content: meidaChannelHtml} = this.$refs.barChartChannelRef;

            let healthContents = utils.ContentStrCovertArray(healthLineHtml);
            let affectContents = utils.ContentStrCovertArray(affectHtml);
            let riskLevelContents = utils.ContentStrCovertArray(this.setRiskContent);
            let meidaChannelContents = utils.ContentStrCovertArray(meidaChannelHtml);

            let charts = [
                {
                    "id_name": "rep_title1",
                    "type": "text",
                    "data": `${this.target1.name} VS ${this.target2.name}`
                },
                {
                    "id_name": "rep_time",
                    "type": "text",
                    "data": `${this.dateRange}`
                },
                {
                    "id_name": "rep_title2",
                    "type": "text",
                    "data": ``//TODO data数据
                },

                covertData.lineHealth_ppt({
                    heads:["日期", this.target1.name, this.target2.name],
                    target1: this.target1.healths,
                    target2: this.target2.healths,
                    text: `${healthContents[0]}。\n${healthContents[1]}。`
                }),


                covertData.areaHealthBar_ppt({
                    id_name: "cmp_hy_diqzhis_2_bar",
                    heads: [" ", this.target2.name],
                    list: this.target2.spreadStats.fameHealthyMap,
                }),

                covertData.affectBar_ppt({
                    heads: [" ", this.target1.name, this.target2.name],
                    text: `${affectContents[0]}。\n${affectContents[1]}。`,
                    target1: this.target1.spreadStats.broadcastEffect,
                    target2: this.target2.spreadStats.broadcastEffect
                }),

                covertData.riskStatsBar_ppt({
                    heads:[" ", this.target1.name],
                    list: this.target1.general.yinbaoRiskCounts,
                    text: `${riskLevelContents[0]}。\n${riskLevelContents[1]}。`
                }),

                covertData.riskStatsBar_ppt({
                    id_name: "cmp_hy_10fx_2_bar",
                    heads:[" ", this.target2.name],
                    list: this.target2.general.yinbaoRiskCounts
                }),

                covertData.riskLevelBar_ppt({
                    heads:[" ", this.target1.name, this.target2.name],
                    target1: this.target1.general.riskLevelCounts,
                    target2: this.target2.general.riskLevelCounts
                }),
                covertData.riskLevelBar_ppt({
                    heads:[" ", this.target1.name, this.target2.name],
                    target1: this.target1.general.riskLevelCounts,
                    target2: this.target2.general.riskLevelCounts
                }),


                covertData.channelStats_ppt({
                    heads:[" ", this.target1.name, this.target2.name],
                    target1: this.target1.spreadStats.channelTendency,
                    target2: this.target2.spreadStats.channelTendency,
                    text:`${meidaChannelContents[0]}。\n${meidaChannelContents[1]}。`
                }),

                covertData.compareMediaTable_ppt({
                    data:[[`对比${this.entityLabel}`], [this.target1.name], [this.target2.name]]
                }),
                covertData.moduleStr_ppt({
                    id_name: "media_tendency_percent_title",
                    type: "text",
                    data: `敏感在全部中占比`
                }),

                //this.tableData
                covertData.compareMediaBar_ppt({list: this.tableData.body}),
                covertData.compareMediaTablePercent_ppt({ list: this.tableData.body}),

                //重点事件
                covertData.moduleStr_ppt({
                    id_name: "cmp_hy_zdshjian_title_1",
                    data: `3·2 重点事件 - ${this.target1.name}`
                }),
                covertData.moduleStr_ppt({
                    id_name: "cmp_hy_zdshjian_intro_1",
                    data: `${this.tagrget1MainEventStr}`
                }),
                covertData.moduleStr_ppt({
                    id_name: "cmp_hy_zdshjian_title_2",
                    data: `3·2 重点事件 - ${this.target2.name}`
                }),
                covertData.moduleStr_ppt({
                    id_name: "cmp_hy_zdshjian_intro_2",
                    data: this.tagrget2MainEventStr
                }),

            ];
            if(this.paramsData.type == "industry"){

                //地域健康度指数
                let {content: areaHealthHtml} = this.$refs.areaHealthRef
                let areaHealthContents = utils.ContentStrCovertArray(areaHealthHtml)
                charts.push(covertData.areaHealthBar_ppt({
                    heads:[" ", this.target1.name],
                    list: this.target1.spreadStats.fameHealthyMap,
                    text: `${areaHealthContents[0]}。\n${areaHealthContents[1]}。`
                }));

                // 风险企业
                let {content: riskCompanyStr} = this.$refs.riskCompanyRef;

                let riskCompanyContents = utils.ContentStrCovertArray(riskCompanyStr)

                charts = charts.concat(
                    ...covertData.riskCompany_ppt({
                        title: "2·2 风险企业分布",
                        text: `${riskCompanyContents[0]}。\n${riskCompanyContents[1]}。` ,
                        name:this.target1.name,
                        ...this.target1.general.subCompanyHealth
                    }).concat(
                    ...covertData.riskCompany_ppt({
                        name:this.target2.name,
                        pieIdName: "cmp_hy_fxqiye_2_pie",
                        titleIdName: "cmp_hy_fxqiye_2_label_title",
                        infoIdName:"cmp_hy_fxqiye_2_label_infor",
                        ...this.target2.general.subCompanyHealth
                    })))
            }

            //近期报道
            covertData.htmlTocanvas(this.$refs[`target1PosImage`]).then(data => {
                charts.push(covertData.comparePicture_ppt({"id_name": "p4_positive_picture", data}))
            })
            covertData.htmlTocanvas(this.$refs[`target1NegImage`]).then(data => {
                charts.push(covertData.comparePicture_ppt({"id_name": "p4_sensitive_picture", data}))
            })
            covertData.htmlTocanvas(this.$refs[`target2PosImage`]).then(data => {
                charts.push(covertData.comparePicture_ppt({"id_name": "cmp_hy_zdshjian_2_positive_picture", data}))
            })
            covertData.htmlTocanvas(this.$refs[`target2NegImage`]).then(data => {
                charts.push(covertData.comparePicture_ppt({"id_name": "cmp_hy_zdshjian_2_sensitive_picture", data}))
            })

            let pptData = {
                // "name": "对比",
                "template": `${this.target1.name} VS ${this.target2.name}.pptx`,
                "pptcode": covertData.getComparePptCode(this.paramsData.type),
                "charts": charts,
                // "articles": [],
                "customer": {
                    "code": "xinhua",
                    "name": "xinhua"
                },
                "project": {
                    "code": "xinhua",
                    "name": "xinhua"
                }
            }
            setTimeout( ()=>{
                // console.log("compare pptData:",JSON.stringify(pptData), charts)
                sessionStorage.setItem('sendEmailPptData', JSON.stringify(pptData));

            },1000)
        },

        canvasImage(){
            //生成报告图片
            let _self = this;
            setTimeout( ()=>{
                covertData.htmlTocanvas(_self.$refs[`compareBox`]).then(data => {
                    sessionStorage.setItem('imageData', JSON.stringify({data}));
                })
            },1000)
        }
    }
}
</script>

<style lang="scss" scoped>
.DataCompare {
    padding-bottom: 60px;
    .compareTop {
        width: 100%;
        height: 84px;
        background-image: url("../assets/img/compare/CompareTop.png");
        background-size: 100% 100%;
        position: relative;
        padding: 18px 0 10px;
        .viewImg {
            width: 16px;
            position: absolute;
            top: 12px;
            right: 16px;
        }
        .titleBox {
            margin-bottom: 8px;
            p { width: 50%; line-height: 33px; }
        }
    }
    .articleBox{
        font-family: PingFangSC-Regular;
        .homeComTitle { padding: 0 20px; }
        .event_desc{
            padding: 12px 16px 0px 16px;
        }
        .titleImg { width: 80px;}

    }

    .footControlBox {
        width: 100%;
        height: 48px;
        line-height: 48px;
        p {
            width: 50%;
            &:nth-child(1) {
                background-color: #F29E01;
            }
            &:nth-child(2) {
                background-color: #376CCF;
            }
        }
    }
    .exportBtn {
      position: fixed;
      left: 0;
      bottom: 0;
      width: 100%;
    }
}
</style>